// More types exposed from `index.d.ts`.
export {VFile} from './lib/index.js'
